import Cookies from 'js-cookie';

export class AppStorage{
    static ACCESS_TOKEN = 'ACCESS_TOKEN';
    static REFRESH_TOKEN = 'REFRESH_TOKEN';

    static getCookieByKey = async (key: string) =>{
        try{
            return await Cookies.get(key);
        }catch(e){
            console.error('AppStorage', 'getCookieByKey', e);
        }
    }

    static saveCookie = async (key: string, value: any) : Promise<string | undefined>=>{
        try{ 
            return await Cookies.set(key, JSON.stringify(value));
        }catch(e){
            console.error('AppStorage', 'saveCookie', e);
        }
    }

    static removeCookie = async (key: string): Promise<void | undefined>=>{
        try{
            await Cookies.remove(key);
        }catch(e){
            console.error('AppStorage', 'removeCookie', e);
        }
    }

    static getAccessToken = async ()=>{
        const accessToken: string | undefined = await AppStorage.getCookieByKey(AppStorage.ACCESS_TOKEN);
        return accessToken? accessToken : undefined;
    }

    static getRefreshToken = async ()=>{
        const refreshToken: string | undefined = await AppStorage.getCookieByKey(AppStorage.REFRESH_TOKEN);
        return refreshToken? refreshToken : undefined;
    }

    static saveToken = async (isRefresh: boolean, value: string) =>{
        return await Cookies.set((isRefresh? AppStorage.REFRESH_TOKEN : AppStorage.ACCESS_TOKEN), value);
    }
}